import styled from "styled-components";

export const ExpandableContainer = styled.div`
  background: #fbfaff;
  padding: 22px;
  border-radius: 1rem;
  width: -webkit-fill-available;
  margin-bottom: 1.5rem;
`;

export const TitleContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const MainTitle = styled.h1`
  color: #0d51f1;
  font-family: Mulish, sans-serif;
  font-size: 1.25rem;
  font-weight: bold;

  @media screen and (max-width: 600px) {
    font-size: 1rem;
  }
`;

export const Description = styled.p`
  color: #737373;
  font-size: 1.25rem;
  font-family: Campuni;
  margin-top: 1.5rem;

  @media screen and (max-width: 600px) {
    font-size: 0.875rem;
    margin-top: 1rem;
  }
`;
